<template>
<div>
 <v-overlay :value="overlay" z-index="999">
    <v-progress-circular class="center" indeterminate size="40"/>
  </v-overlay>
</div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'OverlayLoading',
  computed: {
    overlay: get('app/loading')
  }
}
</script>

<style lang="scss" scoped>
.center {
  top: 50%;
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
}
</style>
